import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NuevaZonaComponent } from 'src/app/components/portal-cliente/zonas-grupos/formularios/nueva-zona/nueva-zona.component';
import { NuevoGrupoComponent } from 'src/app/components/portal-cliente/zonas-grupos/formularios/nuevo-grupo/nuevo-grupo.component';
import { InstalacionesAsignadasComponent } from 'src/app/components/portal-cliente/zonas-grupos/formularios/instalaciones-asignadas/instalaciones-asignadas.component';


//Servicios
import { ZonaService } from 'src/app/services/zona.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { GrupoService } from 'src/app/services/grupo.service';
import { InstalacionesAsignadasGruposComponent } from './formularios/instalaciones-asignadas-grupos/instalaciones-asignadas-grupos.component';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-zonas-grupos',
  templateUrl: './zonas-grupos.component.html',
  styleUrls: ['./zonas-grupos.component.scss']
})
export class ZonasGruposComponent implements OnInit {

  public userLogged: any
  role:any
  public zonas: any
  public loading: any
  public instalaciones: any
  public zonaSeleccionado: any;
  public nameZone: any

  //grupos
  public grupos: any
  public campos : any
  public idGrupo: any
  public inputNameGrupo: any = "Nuevo Grupo"
  public grupoSeleccionado: any
  public campoSeleccionado: any
  public grupoFiltrado: any
  public campoFiltrado: any
  public campoInstalaciones: any

  constructor(public dialog: MatDialog, private apollo: Apollo, 
    private zonaService: ZonaService,
    private grupoService: GrupoService,
    private loginService: LoginService) { 
      this.userLogged = loginService.getUserData()
      this.role = this.userLogged.rol
      console.log(this.userLogged)
    }

  ngOnInit(): void {
    this.getZonasByCliente() 
    this.getGruposByCliente()
  }


  openDialog() {
    this.dialog.open(NuevaZonaComponent);
  }


  openDialogGrupo(grupo:any) {
    this.dialog.open(NuevoGrupoComponent,{data:{
      grupo
    }});
   
  }


  openDialogCambiarzg() {
    this.dialog.open(InstalacionesAsignadasComponent);
  }

  openDialogCambiarGrupo(grupo:any) {
    this.dialog.open(InstalacionesAsignadasGruposComponent, {
      data:{
        grupo
      }
    });
  }


  getZonasByCliente() {
    this.apollo.watchQuery<any>({
      query: this.zonaService.getZonasByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        console.log(data)
        this.zonas = data.cliente.zonas
        /* console.log(this.zonas) */
      });
    
  }

  selectZona(e:any){
    this.zonaSeleccionado = e;
    this.getInstalacionesByZona();
    this.getNameSelectedZone();
  }

  getNameSelectedZone(){
    const nameZone = this.zonas.filter((zona:any)=> this.zonaSeleccionado == zona.id);
    this.nameZone = nameZone[0];
  }

  getInstalacionesByZona(){
    this.apollo.watchQuery<any>({
      query: this.zonaService.getInstalacionesByZona(),

      variables: {
        "id": this.zonaSeleccionado
      }
    }).valueChanges.subscribe(({data, loading, error})=>{
      this.instalaciones = data.zona.instalacions;
      /* console.log(this.instalaciones) */
    })
  }


  getGruposByCliente() {
    this.apollo.watchQuery<any>({
      query: this.grupoService.getGruposByCliente(),
      variables: {
        "id": this.userLogged.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        /* console.log(data) */
        this.grupos = data.cliente.agrupacions
      /*   console.log(this.grupos) */
      });
    
  }

  selectGrupo(e:any){
    this.grupoSeleccionado = e;
    console.log(this.grupoSeleccionado)
    this.getGrupoById()
  }

  getGrupoById() {
    this.apollo.watchQuery<any>({
      query: this.grupoService.getGrupoById(),
      variables: {
        "id": this.grupoSeleccionado
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        /* console.log(data) */
        this.grupoFiltrado = data.agrupacion
        /* console.log(this.grupoFiltrado)  */
        this.campos = this.grupoFiltrado.campos
        /* console.log(this.campos)  */

      });
    
  }

  selectCampo(e:any){
    this.campoSeleccionado = e;
    /* console.log(this.campoSeleccionado) */
    this.getCampoById() 
  }

  getCampoById() {
    this.apollo.watchQuery<any>({
      query: this.grupoService.getInstalacionesByCampo(),
      variables: {
        "id": this.campoSeleccionado
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
      /*   console.log(data)  */
        this.campoFiltrado = data.campo
       /*  console.log(this.campoFiltrado) */
        this.campoInstalaciones = this.campoFiltrado.instalacions
        /* console.log(this.campoInstalaciones); */
        

      });
  }
 
  addGrupo(){
    this.apollo.mutate<any>({
      mutation: this.grupoService.addGrupo(),
      variables: {
        "input": {
          "data": {
            "nombre": this.inputNameGrupo,
            "cliente": this.userLogged.cliente.id
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('CREADO', data)
      location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  

  }
  


